import { AGENCY_INCLUDED_SEATS } from "features/subscriptions/constants";
import useAgencyPurchaseMinSeats from "features/subscriptions/hooks/useAgencyPurchaseMinSeats";

import type { PricingPeriodInfo, SubscriptionType } from "common/types";

export default function useMinSeatQuantity(
  subscriptionType: SubscriptionType,
  hasActiveSubscription: boolean,
  pricingPeriodInfo?: PricingPeriodInfo,
) {
  const isAgencyPurchase =
    subscriptionType === "agency" && !hasActiveSubscription;

  const {
    minSeats: agencyPurchaseMinSeats,
    totalActiveOutreachSeats,
    outreachSeatBreakdown,
  } = useAgencyPurchaseMinSeats(isAgencyPurchase);

  let minSeatQuantity: number;

  if (subscriptionType === "agency") {
    minSeatQuantity = isAgencyPurchase
      ? agencyPurchaseMinSeats
      : AGENCY_INCLUDED_SEATS;
  } else if (subscriptionType === "rental") {
    if (hasActiveSubscription) {
      minSeatQuantity = 0;
    } else {
      //the minimum of 3 Avatars only applies to the monthly plan, the 3 month
      //plan can be purchased with a single Avatar
      const isThreeMonthPlan =
        pricingPeriodInfo?.period_unit === "month" &&
        pricingPeriodInfo.period === 3;

      minSeatQuantity = isThreeMonthPlan ? 1 : 3;
    }
  } else {
    minSeatQuantity = hasActiveSubscription ? 0 : 1;
  }

  return {
    minSeatQuantity,
    isAgencyPurchase,
    agencyPurchaseMinSeats,
    totalActiveOutreachSeats,
    outreachSeatBreakdown,
  };
}
